import { apiQuery, deleteCommand, findOneCommand, queueQuery, updateCommand } from './templates';
import * as _ from 'underscore';
import NProgress from 'nprogress';
import swal from 'sweetalert2';
import moment from 'moment-timezone';
import * as async from 'async';
import feather from 'feather-icons';
import { Document } from './Document';
window.feather = feather;

class OBTODocumentController extends Document {

    constructor($window, $timeout, $compile, pageService, $http, $routeParams, $rootScope, $location, ribbon, $uibModal, API, $localstorage, $log, $anchorScroll, OB, $route, $document, $ngRedux, $scope) {
        super($window, $timeout, $compile, pageService, $http, $routeParams, $rootScope, $location, ribbon, $uibModal, API, $localstorage, $log, $anchorScroll, OB, $route, $document, $ngRedux, $scope);
        this.$scope = $scope;
        this.$window = $window;
        this.$timeout = $timeout;
        this.$compile = $compile;
        this.pageService = pageService;
        this.$http = $http;
        this.$routeParams = $routeParams;
        this.$rootScope = $rootScope;
        this.$location = $location;
        this.ribbon = ribbon;
        this.$uibModal = $uibModal;
        this.API = API;
        this.$localstorage = $localstorage;
        this.$log = $log;
        this.$anchorScroll = $anchorScroll;
        this.OB = OB;
        this.$route = $route;
        this.$document = $document;
        this.$ngRedux = $ngRedux;
    }

    $onDestroy() {
        this.deRegister3();
        this.deRegister2();
        this.deRegister();
        this.deregister4();
        // this.deregister5();
        this.deregister6();
        this.deregister7();
        this.$log.info("Unsubscribing..." + `${this.values.domain}/document/update/${this._docId}`);
        this.$ngRedux.dispatch({
            type: 'UPDATE',
            payload: {
                "formReady": false
            }
        });
        try {
            this.$window.client.unsubscribe(`${this.values.domain}/document/view/${this._docId}`);
            this.$window.client.unsubscribe(`${this.values.domain}/document/update/${this._docId}`);
        } catch (e) {

        }
    }

    $onInit() {

        console.log('1=============>');
        this.whichCodeEditor = this.$localstorage.getObject("ob.props")['co.obto.platform.code.editor'] || "monaco";
        try {
            feather.replace({
                width: 18,
                height: 18,
            });

        } catch (e) {

        }

        this.$scope.$on('$destroy', () => {
            // console.log("In destroy of:....sub");
        });



        let embedded = this.embedded || false;
        embedded = embedded.toString() === "true";
        const serverScripts = {};
        const clientScripts = {};
        let matchScriptNames = "";
        let formConnected = false;
        this.access = {};
        this.access.upload = false;
        this.access.download = false;
        this.access.addfield = false;
        this.access.json = true;
        this.access.addfield = true;
        this.attachments = [];
        this.fields = {};
        this.ui_actions = [];
        this.values = {};
        this._oldValues = {};
        this._newValues = {};
        this.fieldValue = {};
        this.fieldOption = {};
        this.allFieldsOption = {};
        this.actionVisible = {};
        this.modifiedFieldValue = {};
        this.onChange = [];
        this.onLoad = {};
        this.dependency = [];
        this.fieldVisibility = {};
        this.isHidden = {}; //To hide fieldsth
        this.fieldDisabled = {}; //To make field readonly//ng-disabled="disableDate(field.name)"
        this.fieldRequired = {}; //To make field required
        this.fieldCSS = {}; //To change field css
        this.successFlag = false;
        this.errorFlag = false;
        this.success_message = "";
        this.remoteUpdated = {};
        this.error_message = "";
        this.inputModel = [];
        this.form = {};
        // this.collection = this.collection;
        this.$scope.gridOptions = {
            gridHeight: 'auto',
            embedded: true
        };
        const normalizeFieldMap = {};
        const normalizedFieldsObject = {};
        const o = {
            root: this.$rootScope,
            scope: this,
            timeout: this.$timeout,
            http: this.$http,
            window: this.$window,
            moment: moment,
            _: _,
            routeParams: this.$routeParams,
            beautify: this.bjs,
            scrollTo: this.$anchorScroll,
            location: this.$location,
            modal: this.$uibModal,
            async: async,
            API: this.API,
            localStorage: this.$localstorage,
            service: this.OB
        };
        const collection = this.$routeParams.document || this.collection;
        const document = this.$routeParams.id || this.document;
        this.editor = {};
        this.aceeditor = {};
        const remoteUpdated = {};
        this.buttons = {};
        this.error_message = "Please check the required fields.";
        this.currentMode = {};
        this.posts = [];
        this._docId = this.document;
        this.fieldModel = {};
        this.editableOptions = {
            mode: 'popup',
            disabled: false
        };
        this.username = 'superuser';

        this.viewMainForm = this.$rootScope.viewFiles + '/form-component-main.html';

        this.mode = "html";
        this.editorView = { 'height': '700px' };
        const allProps = this.$localstorage.getObject("ob.props");
        let USE_SCRIPT_1 = null;
        let response_data_ui_actions;
        let _docId = "";
        let oper = "";
        let error = false;
        let userChangeTriggred = false;

        // this.deregister5 = $scope.$on("$destroy", () => {
        //     formConnected = false;
        // });

        this.deRegister =  this.$ngRedux.subscribe(() => {

            let state =  this.$ngRedux.getState();
            if (state.appState.formReady) {
                let templateName = collection;
                let targetPages = ['ob-connect', 'sofos-notice-board', 'imitate', 'ob-domains', 'switchdomain', 'changeset'];
                setTimeout(() => {
                    if (targetPages.indexOf(templateName) === -1) {
                        let title = templateName.replace(/[_-]/g, " ");
                        title = title.replace("pltf", "").trim();
                        title = title.replace(".html", "").trim();
                        title = title.replace("v2", "").trim();
                        title = title.charAt(0).toUpperCase() + title.slice(1);
                        this.$rootScope.$broadcast('event:titlechanged', title);
                    }
                }, 400);

                if (Object.keys( this.onLoadFunction).length !== 0) {
                    const _o = {
                        root:  this.$rootScope,
                        scope:  this.$scope,
                        timeout:  this.$timeout,
                        http:  this.$http,
                        window:  this.$window,
                        moment: moment,
                        _: _,
                        routeParams:  this.$routeParams,
                        scrollTo:  this.$anchorScroll,
                        location:  this.$location,
                        modal:  this.$uibModal,
                        async: async,
                        API:  this.API,
                        localStorage:  this.$localstorage,
                        service:  this.OB
                    };

                    async.eachSeries(this.onLoadFunction, (element, _cb) => {
                        let USE_SCRIPT = null;
                        try {
                            this.$scope.$eval(new Function("try { " + element._func + "} catch(err){ console.log(err)}")()(this,  this.$rootScope, _o, this.aceeditor));
                        } catch (e) {
                            this.$log.log(e);
                            console.error(element.name, JSON.stringify(e));
                        }
                        _cb();
                    }, err => {
                        this.$scope.$applyAsync();
                    });
                }
            }
        });

        this.applyFieldValues = () => {

        };

        this.tinymceModel = 'Initial content';

        this.getContent = () => {
            this.$log.debug('Editor content:', this.tinymceModel);
        };

        this.setContent = () => {
            this.tinymceModel = 'Time: ' + (new Date());
        };

        this.tinymceOptions = {
            plugins: 'link image code, fullscreen',
            height: "480",
            toolbar: 'undo redo | bold italic | alignleft aligncenter alignright | code | fullscreen',
            init_instance_callback: (editor) => {
                editor.on('Change', (e) => {
                    this.$log.debug('Editor contents was changed.');
                    this.$log.debug(editor.getContent());
                    this.modifiedFieldValue['script'] = editor.getContent();
                });
            }
        };

        // JavaScript Version
        this.validate = () => {
            angular.forEach(this.obtoform, (control, name) => {
                // Excludes internal angular properties
                if (typeof name === 'string' && name.charAt(0) !== '$') {
                    // To display ngMessages
                    control.$setTouched();
                    // Runs each of the registered validators
                    control.$validate();
                }
            });
        };

        this.resetUiActions = (on_change) => {
            const ui_actions = response_data_ui_actions;
            const actionVisible = {};
            this.$log.info("ui_actions", ui_actions);
            ui_actions.map(val => {
                const USE_SCRIPT = (val.compiled) ? val.compiled.code : val.handler;
                actionVisible[val._id] = false;
                val.handler = () => {
                    // const originalModifiedObject = this.modifiedFieldValue;
                    new (`t=>ry { ${USE_SCRIPT} return _func(); } catch(err) { console.log(${val.name}, err)}`)()(o);
                    validate();
                    this.$timeout(() => {
                        this.submitForm();
                    }, 500);
                };

                if (val.condition) {
                    const field_values = on_change ? this.modifiedFieldValue : this.values;
                    try {
                        actionVisible[val._id] = new (`t=>ry { ${val.condition} } catch(err) { console.log(${val.name}, err)}`)()(o, field_values);
                        this.log.debug("actionVisible", actionVisible);
                    } catch (e) {
                        // throw e;
                        this.$log.error(e);
                    }
                }

                return val;
            });
            this.ui_actions = ui_actions;
            this.actionVisible = Object.assign(this.actionVisible, actionVisible);
        };

        this.fetchFieldAt = (map) => {
            return normalizeFieldMap[map] ? normalizeFieldMap[map] : false;
        };

        const form = {};
        const sectionValid = {};
        let formRow = [];

        const fetchFormStructure = (c) => {
            this.$http.get(`/o/form/${collection}/${document}`).then((response) => {
                if (response.status === 200) {
                    this._docId = document;
                    const values = {};
                    // console.log('6======>')
                    response.data.sections.map((sec) => {
                        form[sec.name] = [];
                        sectionValid[sec.name] = true;
                        sec.classes = 'ob-tab-required';
                        const fields = response.data.fields.filter(val => val.section_name === sec.name).sort((a, b) => (parseInt(a.row_id) - parseInt(b.row_id) || parseInt(a.column_id) - parseInt(b.column_id)));
                        // console.log('fields', fields);
                        fields.forEach(field => {

                            const fn = field.name;
                            remoteUpdated[fn] = false;
                            // if (field.input_type === 'code') {
                            //     this.editor[fn] = {};
                            //     this.aceeditor[fn] = {};
                            //     this.editor[fn].theme = this.$localstorage.getObject("ob.props")['co.obto.editor.theme'] || "chaos";
                            //     this.editor[fn].code = "";
                            // }


                            this.fieldValue[field.name] = "";
                            if (!normalizeFieldMap[field.map]) {
                                normalizeFieldMap[field.map] = field;
                            }

                            if (!normalizedFieldsObject[field.name]) {
                                normalizedFieldsObject[field.name] = field;
                            }

                            if (field.input_type === 'option') {
                                const fieldOptions = response.data.option.filter(val => val.field === field.name);
                                fieldOptions.unshift({ id: '', name: 'None', field: field.name });
                                this.fieldOption[field.name] = fieldOptions;
                                this.allFieldsOption[field.name] = this.fieldOption[field.name];
                                values[field.name] = '';
                            }

                            if (this._docId === "new" && field.default_value) {
                                values[field.name] = field.default_value;
                                this.modifiedFieldValue[field.name] = field.default_value;
                            }

                            let isFullLength = false;
                            if (['document_editor', 'code', 'tarea'].includes(field.input_type)) {
                                isFullLength = true;
                            }
                            if (formRow.length === 2) {
                                form[sec.name].push(formRow);
                                formRow = [];
                            }

                            if (isFullLength && !formRow.length) {
                                formRow.push(field);
                                form[sec.name].push(formRow);
                                formRow = [];
                            }

                            if (isFullLength && formRow.length) {
                                form[sec.name].push(formRow);
                                formRow = [];
                                formRow.push(field);
                                form[sec.name].push(formRow);
                                formRow = [];
                            }

                            if (!isFullLength && formRow.length === 1 && field.row_id !== formRow[0].row_id) {
                                form[sec.name].push(formRow);
                                formRow = [];
                            }

                            !isFullLength && formRow.push(field);
                        });

                        return sec;
                    });

                    if (response.data.data.length) {
                        _.extend(values, response.data.data[0]);
                    }

                    this.form = form;
                    console.log('2======>')

                    this.sections = response.data.sections;
                    this.sectionValid = sectionValid;
                    this.values = values;
                    _.extend(this, response.data);
                    response_data_ui_actions = response.data.ui_actions;
                    console.log('3======>')
                    this.rsections = (this._docId === "new") ? [] : this.rsections;
                    console.log('4======>')
                    c(null, 1);
                }
            });
        };

        const fetchRecord = (c) => {
            if (document !== "new") {
                this.isUpdate = true;
                this.isInsert = false;
                if (!_.isUndefined(collection)) {
                    this.resetUiActions();
                    c(null, 2);
                }
            } else {
                c(null, 2);
            }
        };

        const initiate = [fetchFormStructure, fetchRecord];

        const loadDocument = (n, o) => {
            this.$log.info('Loading data');
            // NProgress.start();
            if (typeof n === 'undefined') {
                // NProgress.done();
                return false;
            }

            if (this._docId === "new" || Object.keys(this.values).length !== 0) {
                async.each(this.fields, (v, cb) => {
                    let fo = v;
                    const fn = fo.name;
                    this.fieldCSS[fn] = "input-group"; //(!fo.mandatory) ? "input-group" : "input-group has-error";
                    this.fieldValue[fn] = this.values[fn] ? this.values[fn] : "";
                    this.fieldRequired[fn] = _.isUndefined(fo.mandatory) ? false : fo.mandatory; //false;
                    this.fieldDisabled[fn] = _.isUndefined(fo.readonly) ? false : fo.readonly; //false;
                    this.isHidden[fn] = !(fo.form_view && fo.form_view.toString() === 'true');
                    if (['updated_on', 'updated_by', 'created_on', 'created_by'].includes(fn)) {
                        this.fieldDisabled[fn] = true;
                    }

                    if (fn === 'domain')
                        this.fieldDisabled[fo.name] = true;

                    if (fo.input_type === 'document_editor') {
                        const _script = this.values[fn] || 'Initial content';
                        if (typeof _script === 'string') {
                            this.fieldValue[fn] = this.values[fn];
                        }
                        if (typeof _script === 'object') {
                            this.fieldValue[fn] = JSON.stringify(this.values[fn]);
                        }
                    }

                    if (fo.input_type === 'datetime') {
                        this.fieldValue[fn] = (typeof this.values[fn] !== "undefined") ? new Date(this.values[fn]) : "";
                        return cb();
                    }

                    if (fo.input_type === 'date') {
                        const setValue = (typeof this.values[fn] !== "undefined") ? new Date(this.values[fn]) : ""; //this.values[fo.name] || new Date();
                        this.fieldPops[fn] = {
                            opened: false
                        };
                        this.fieldValue[fn] = setValue;
                        return cb();
                    }

                    if (fo.input_type === 'checkbox') {
                        if (typeof this.values[fn] === 'undefined') {
                            this.fieldValue[fn] = false;
                            return cb();
                        }

                        this.fieldValue[fn] = this.values[fn] && this.values[fn].toString() === "true";

                        return cb();
                    }

                    if (fo.input_type === 'image') {
                        this.fieldValue[fn] = "data:image/jpg;base64," + window.btoa(this.values[fn]);
                    }

                    //Check if I am a dependent field
                    const dependentFields = this.fields.filter(val => val.dependency === fn);
                    dependentFields.forEach((val) => {
                        // console.log("this.allFieldsOption[val.name];", val.name);
                        const allFieldsOptions = this.allFieldsOption[val.name];
                        const dependentFieldName = fn;
                        const dependentFieldValue = this.fieldValue[fn];
                        if (!dependentFieldValue) {
                            this.fieldOption[val.name] = this.allFieldsOption[val.name];
                            return;
                        }
                        if (allFieldsOptions) {
                            this.fieldOption[val.name] = allFieldsOptions.filter(val => val.dependent_field === dependentFieldName && val.filter === dependentFieldValue);
                        } else {
                            this.fieldOption[val.name] = [];
                        }

                    });//Divy

                    cb();
                }, (e) => {

                    if (this._docId !== "new") {

                        this.remoteUpdated = {};

                        this.deregister4 = this.$ngRedux.subscribe(() => {
                            let state = this.$ngRedux.getState();
                            if (state.appState.events && state.appState.events.event === `event:${this.values.domain}/document/update/${this._docId}`) {
                                const data = state.appState.events.data.msg;
                                this.remoteUpdated = {};
                                let _remoteUpdated = {};
                                Object.keys(data.payload).forEach(key => {
                                    _remoteUpdated[key] = true;
                                    if (key === "updated_on") {
                                        this.fieldValue[key] = new Date(data.payload[key]);
                                    } else {
                                        this.fieldValue[key] = data.payload[key];
                                    }
                                });
                                this.remoteUpdated = _remoteUpdated;
                                // this.$applyAsync();
                                try {
                                    feather.replace({
                                        width: 18,
                                        height: 18,
                                    });
                                } catch (e) {

                                }
                            }
                        });

                        this.deRegister2 = this.$ngRedux.subscribe(() => {
                            let state = this.$ngRedux.getState();
                            if (state.appState.events && state.appState.events.event === `event:${this.values.domain}/document/view/${this._docId}`) {
                                remoteBeingViewed[state.appState.events.data.msg.from] = state.appState.events.data;

                                const getInitialsPayload = { first: "", last: "" };
                                const name = (state.appState.events.data.msg.fromName) ? state.appState.events.data.msg.fromName.split(" ") : ["OBTO", "User"];
                                getInitialsPayload.first = name[0];
                                getInitialsPayload.last = (name[1]) ? name[1] : "";
                                remoteBeingViewed[state.appState.events.data.msg.from].dp = OB.getInitials(getInitialsPayload);

                                this.remoteBeingViewed = remoteBeingViewed;
                                // this.$applyAsync();
                            }
                        });

                        this.deRegister3 = this.$ngRedux.subscribe(() => {
                            let state = this.$ngRedux.getState();
                            if (state.login.socketStatus && state.login.socketStatus.status === 'ready' && !formConnected) {
                                if (this._docId !== 'new' && typeof this.$window.client === 'object') {
                                    this.$window.client.subscribe(`${this.values.domain}/document/update/${this._docId}`);
                                    this.$window.client.subscribe(`${this.values.domain}/document/view/${this._docId}`);
                                    this.$window.client.publish(`${this.values.domain}/document/view/${this._docId}`, JSON.stringify({
                                        uid: uuidv4(),
                                        msg: {
                                            dp: this.$rootScope.user.display_picture_url,
                                            from: this.$rootScope.user._id,
                                            domain: this.$rootScope.ob.domain,
                                            fromName: this.$rootScope.user.name
                                        }
                                    }));
                                    setInterval(() => {
                                        this.$window.client.publish(`${this.values.domain}/document/view/${this._docId}`, JSON.stringify({
                                            uid: uuidv4(),
                                            msg: {
                                                dp: this.$rootScope.user.display_picture_url,
                                                from: this.$rootScope.user._id,
                                                domain: this.$rootScope.ob.domain,
                                                fromName: this.$rootScope.user.name
                                            }
                                        }));
                                    }, 10000);
                                    this.$log.info("Client Subscribing..." + `${this.values.domain}/document/update/${this._docId}`);
                                    formConnected = true;
                                }
                            }
                        });

                    } else {

                        if (!_.isUndefined(collection))
                            userChangeTriggred = true;

                        this.isUpdate = false;
                        this.isInsert = true;
                        this.$http.get("/o/sequence.bto/" + collection).then((response) => {
                            if (response.status === 200) {
                                if (this.fieldValue.hasOwnProperty('sequence')) {
                                    this.fieldValue["sequence"] = response.data.value;
                                    this.modifiedFieldValue["sequence"] = response.data.value;
                                }
                                if (this.fieldValue.hasOwnProperty('number')) {
                                    this.fieldValue["number"] = response.data.value;
                                    this.modifiedFieldValue["number"] = response.data.value;
                                }

                            } else {
                                $log.log('Error');
                            }
                            NProgress.done();
                        });
                    }

                    console.log('this.fieldValue', this.fieldValue);

                    // this.$scope.$digest(() => {
                    //     this.remoteUpdated = remoteUpdated;
                    //     userChangeTriggred = true;
                    // });
                    // $compile(element.contents())($scope);
                    // this.activeTab = 1;
                    // NProgress.done();
                    // const linkFn = $compile();
                    // const content = linkFn($scope);
                    // element.append(content);
                    this.activeTab = 1;
                    NProgress.done();
                });
            }
        };

        const saveFile = (name, type, data) => {
            if (data != null && navigator.msSaveBlob)
                return navigator.msSaveBlob(new Blob([data], { type: type }), name);
            let a = $("<a style='display: none;'/>");
            let url = window.URL.createObjectURL(new Blob([data], { type: type }));
            a.attr("href", url);
            a.attr("download", name);
            $("body").append(a);
            a[0].click();
            window.URL.revokeObjectURL(url);
            a.remove();
        };

        const jsonView = () => {
            "use strict";
            let jsonViewCb = (response) => {

                "use strict";
                let newWindow = window.open();

                //write the data to the document of the newWindow
                const formatted = bjs(JSON.stringify(response.data), {
                    indent_size: 2,
                    indent_char: " "
                });

                this.$timeout(() => {
                    newWindow.document.write('<pre style="background: darkslateblue;\n' +
                        '    color: white;white-space: pre-wrap;\n' +
                        '    padding: 30px;">' + formatted + '</pre>');
                }, 100);
            };
            this.$http.get(`/jsonexport/${this.collection}/${this._docId}`, {
                // responseType: "arraybuffer"
            }).then(jsonViewCb);
        };

        const pdfView = () => {
            "use strict";

        };

        const jsonDownload = () => {
            "use strict";

            const jsonCb = (response) => {

                saveFile(this.collection + ".json", "data:attachment/json", response.data);
            };

            swal({
                title: "Are you sure?",
                text: "You gotta do what you gotta do",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Yes, download it!",
                cancelButtonText: "No, cancel plz!"
            }).then((result) => {
                if (result.value) {
                    this.$http.get(`/jsonexport/${this.collection}/${this._docId}`, {
                        responseType: "arraybuffer"
                    }).then(jsonCb);
                    swal("Success", "Your file is open right next window :)", "success");
                } else {
                    swal("Cancelled", "Your imaginary file is safe :)", "error");
                }
            });
        };

        this._executeThis = () => {
        };

        this.getTextAreaWidth = ($event) => {
            this.width = $($event.target).parent().outerWidth();
            alert(this.width);

        };

        this.deregister6 = this.$scope.$watch('dnd', (n, o) => {
            if (n) {
                this.dragSpace = { 'background-color': '#F7CA18' };
                this.draggableDiv = { 'margin': '10px' };
                this.droppableCss = {
                    'height': '60px',
                    'width': '100%',
                    'border-color': 'rgb(101, 94, 94)',
                    'border-width': '2px',
                    'border-style': 'dashed',
                    'margin-left': '2px'
                };
            } else {
                this.dragSpace = {};
                this.droppableCss = {};
            }


        });

        this.reply = "";

        this.avatarsrc = "";

        this.transformDate = (d) => {
            const format = this.$rootScope.globalAttributes['co.obto.domain.datetime.format'] || "MMMM Do YYYY h:mm:ss a";
            return moment(d).format(format);
        };

        this._changedField = "updated_on";

        this._sequencer = false;

        this.deregister7 = this.$scope.$watch('fieldValue[_changedField]', (newValue, oldValue) => {
            if (newValue !== oldValue && userChangeTriggred) {
                this._oldValues = this.fieldValue;
                this._newValues = this.modifiedFieldValue;
                this.$log.info(this._changedField + ' oldValue=' + JSON.stringify(this._oldValues));
                this.$log.info(this._changedField + ' newValue=' + JSON.stringify(this._newValues));
            }
        }, true);

        this.updateFieldValue = (field, value) => {
            this.$log.debug(field + '==CALLED==' + value);
            this._changedField = field;
            this.fieldValue[field] = value;
        };

        this.change = (field) => {
            this._changedField = field;
            this.modifiedFieldValue[field] = this.fieldValue[field];
            this.onChange.forEach((element, index) => {
                if (_[index].field === field) {
                    try {
                        this.$scope.$eval(new Function("try { " + element._func + "} catch(err){ console.log(err)}")()(this._oldValues, this._newValues, this.$scope, o, this.aceeditor));
                    } catch (e) {
                        console.error(element.name, JSON.stringify(e));
                    }
                }

            });

            //Check if I am a dependent field
            const dependentFields = this.fields.filter(val => val.dependency === field);
            dependentFields.forEach((val) => {
                const allFieldsOptions = this.allFieldsOption[val.name];
                const dependentFieldName = field;
                const dependentFieldValue = this.modifiedFieldValue[dependentFieldName];
                if (!dependentFieldValue) {
                    this.fieldOption[val.name] = this.allFieldsOption[val.name];
                    return;
                }
                this.fieldOption[val.name] = allFieldsOptions.filter(val => val.dependent_field === dependentFieldName && val.filter === dependentFieldValue);
            });

            if (this.fieldValue[field] && this.fieldValue[field] !== "") {
                this.obtoform.$setDirty();
                this.resetUiActions(false);
            }

        };

        this.matchName = (query) => {
            return (value) => {
                return value[query];
            };
        };

        this.appMode = (fn, m) => {
            if (this.values.modes) {
                this.modifiedFieldValue.modes = {};
                this.modifiedFieldValue.modes = this.values.modes;
            } else {
                this.modifiedFieldValue.modes = {};
            }
            if (m === 1) {
                this.currentMode[fn] = 1;
                this.modifiedFieldValue.mode = 1;

                this.modifiedFieldValue.modes[fn] = 1;
                // this.aceeditor[fn].getSession().setMode("ace/mode/javascript");
            }


            if (m === 2) {
                this.modifiedFieldValue.mode = 2;
                this.modifiedFieldValue.modes[fn] = 2;
                // this.aceeditor[fn].getSession().setMode("ace/mode/jsx");
                this.currentMode[fn] = 2;
            }

            if (m === 3) {
                this.modifiedFieldValue.mode = 3;
                this.modifiedFieldValue.modes[fn] = 3;
                // this.aceeditor[fn].getSession().setMode("ace/mode/html");
                this.currentMode[fn] = 3;
            }

            if (m === 4) {
                this.modifiedFieldValue.mode = 4;
                // this.aceeditor[fn].getSession().setMode("ace/mode/css");
                this.currentMode[fn] = 4;
                this.modifiedFieldValue.modes[fn] = 4;
            }

            if (m === 6) {
                this.modifiedFieldValue.mode = 2;
                this.modifiedFieldValue.modes[fn] = 2;
                // this.aceeditor[fn].getSession().setMode("ace/mode/jsx");
                this.currentMode[fn] = 2;
            }

        };

        this.user = {
            name: 'Hello'
        };

        this.submitForm = () => {
            this.obtoform.$setPristine();
            if (!this.obtoform.$valid || this.obtoform.$invalid) {
                this.errorFlag = true;
                this.$log.debug(this.fieldValue);
                this.$log.debug(this.obtoform);
                return swal("Problem", 'Required field is empty!', "error");
            }
            NProgress.start();

            const cb = (response) => {
                this.dynamic = 100;

                if (response.status !== 200) {
                    this.errorFlag = true;
                    this.error_message = response.status + " : " + response.data.message;
                    swal("Problem", JSON.stringify(response.data), "warning");
                }

                if (response.status === 200 && !embedded) {
                    this.$location.path("/" + this.collection + "/" + response.data._id).replace();
                }

                if (response.status === 200 && embedded) {
                    swal("Success", "Object saved!", "success");
                    setTimeout(() => {
                        this.$rootScope.$emit("event.obtotemplate.reload");
                    }, 1000);
                }

                this.buttons.processing = false;
                this.modifiedFieldValue = {};
                NProgress.done();
                // $route.reload();
            };

            this.modifiedFieldValue["domain"] = this.values['domain'] || this.$rootScope.ob.domain;
            this.$log.debug("this.modifiedFieldValue====>" + JSON.stringify(this.modifiedFieldValue));
            this.$http.post("/o/" + this.collection + "/" + this._docId, this.modifiedFieldValue).then(cb);

        };

        this.setAvatar = () => {
        };

        this.dateOptions = {
            formatYear: 'yy',
            startingDay: 1,
            formatDay: 'dd',
            formatMonth: 'mm'
        };

        let dformat = "dd-MM-yyyy";
        let pickerFormat = this.$rootScope.globalAttributes['co.obto.domain.date.format'];
        if (pickerFormat === 'mm/dd/yy' || pickerFormat === 'mm-dd-yy')
            dformat = 'MM-dd-yyyy';

        this.dateFormat = dformat; //$rootScope.globalAttributes['co.obto.domain.date.format'];

        this.fieldPops = {};

        this.date = {
            value: new Date(),
            showFlag: false
        };

        this.open2 = (name) => {
            this.$log.info(name);
            this.fieldPops[name].opened = true;
        };

        this.goBack = () => {
            this.$timeout(() => {
                this.$location.path(collection + "/list");
            }, 50);
        };

        // this.refresh = () => {
        //     this.$route.reload();
        // };

        this.addnewfield = () => {
            this.$route.reload();
        };

        this.sync = () => {
            this.copied = angular.copy(this.fieldValue);
            this.copied['_csrf'] = this._csrf;
            this.copied['oper'] = "add";
            this.copied['domain'] = this.$rootScope.domain;

            this.$http.post("/o/sync.bto/", {
                collection: this.collection,
                _csrf: this._csrf
            }).then((response) => {
                "use strict";

            });

        };

        this.cni = () => {
            this.copied = angular.copy(this.fieldValue);
            this.copied['_csrf'] = this._csrf;
            this.copied['oper'] = "add";
            this.copied['domain'] = this.$rootScope.domain;
            this.$log.debug("Copied " + JSON.stringify(this.copied));

            if (this.copied.hasOwnProperty('sequence') || this.copied.hasOwnProperty('number')) {
                this.$http.get("/o/sequence.bto/" + this.collection).then((response) => {
                    this.$log.debug(response);
                    if (response.status === 200) {
                        if (this.copied.hasOwnProperty('sequence')) {
                            this.copied["sequence"] = response.value;
                        }
                        if (this.copied.hasOwnProperty('number')) {
                            this.copied["number"] = response.value;
                        }

                    }
                    executeThis();

                });
            } else {
                executeThis();
            }

        };

        const executeThis = () => {

            const cb = (response) => {
                //console.log("RESPOSNE :" + JSON.stringify(response))
                this.dynamic = 100;

                if (response.status === 200) {
                    this.successFlag = true;
                    this.success_message = "Record copied and inserted.";

                    swal({
                        title: "View Copied Record",
                        text: "Would you like to view record?",
                        type: "success",
                        showCancelButton: true,
                        cancelButtonClass: "btn-default",
                        confirmButtonText: "View",
                        confirmButtonClass: "btn-primary"
                    }).then((result) => {
                        if (result.value) {
                            this.$timeout(() => {
                                // swal.close();
                                this.$location.path(this.collection + "/" + response.data._id).replace();
                            }, 100);
                        } else {
                            // swal("Cancelled", "Copy & Insert Action Cancelled.", "error");
                        }
                    });

                } else {
                    this.errorFlag = true;
                    this.error_message = response.status + " : " + response.data.message;
                    swal("Problem", response.data, "warning");
                }

                this.copied = {};

            };

            swal({
                title: "Are you sure?",
                text: "Would you like to copy and insert this record?",
                type: "info",
                showCancelButton: true,
                cancelButtonClass: "btn-default",
                confirmButtonText: "Copy",
                confirmButtonClass: "btn-primary"
            }).then((result) => {
                if (result.value) {
                    this.$http.post("/o/" + this.collection + "/", this.copied).then(cb);
                } else {
                    swal("Cancelled", "Copy & Insert Action Cancelled.", "error");
                }
            });
        };

        this.handleDrop = (item, bin, obin, iobin) => {

            let modalinstance = this.open('mapupdate.html');

            let toBePosted = [];

            let firstChange = {};
            firstChange._id = item;
            firstChange._csrf = this._csrf;
            firstChange._oldValue = obin;
            firstChange.domain = this.$rootScope.domain;
            firstChange.map = bin;
            firstChange.row_id = bin.split("-")[2];
            firstChange.column_id = bin.split("-")[3];
            firstChange.id = "1";
            firstChange.oper = "edit";

            //console.log("Data to be posted : " + JSON.stringify(firstChange));
            //toBePosted.push(firstChange);
            let request = this.$http({
                method: "post",
                url: "/o/pltf_field",
                data: JSON.stringify(firstChange)
            });

            request.then(
                (html) => {
                    //$log.log("Map updated");
                    this.success_message = "Map updated";
                    this.successFlag = true;
                    if (iobin === null)
                        modalinstance.close();

                });

            let secondChange = {};
            secondChange._id = iobin;
            secondChange._csrf = this._csrf;
            secondChange._oldValue = bin;
            secondChange.domain = this.$rootScope.domain;
            secondChange.map = obin;
            secondChange.row_id = obin.split("-")[2];
            secondChange.column_id = obin.split("-")[3];
            secondChange.id = "1";
            secondChange.oper = "edit";
            //console.log("Data to be posted : " + JSON.stringify(secondChange));
            //toBePosted.push(secondChange);
            if (iobin !== null) {
                let request2 = this.$http({
                    method: "post",
                    url: "/o/pltf_field",
                    data: JSON.stringify(secondChange)
                });

                request2.then(
                    (html) => {
                        $log.log("Map updated");
                        this.success_message = "Map updated";
                        this.successFlag = true;
                        modalinstance.close();

                    });
            }

        };

        this.updateUserImage = (name) => {
            this.modifiedFieldValue[name] = "";
            this.modifiedFieldValue[name] = window.atob(this.fieldValue[name].split(',')[1]);
        };

        this.convertImage = (name) => {
            return "data:image/jpg;base64," + window.btoa(this.fieldValue[name]);
        };

        this.open = function (name, field, fieldValue, useFor = null, action = () => { }) {
            let size = 'xl';

            if (name === "relation.html" || name === "showattachments.html" || name === "notifynow.html" || name === "avatar.html") {
                NProgress.done();
                size = 'xl';
            }

            const document = this.values;
            let modalInstance = this.$uibModal.open({
                templateUrl: name,
                controller: 'ModalInstanceCtrl3',
                size: size,
                windowTopClass: 'obto-modal-document right',
                // openedClass: 'modal-dialog-slideout',
                animation: false,
                resolve: {
                    parentScope: () => {
                        return this;
                    },
                    name: function () {
                        return name;
                    },
                    action: () => {
                        return action;
                    },
                    rootScope: () => {
                        return this.$rootScope;
                    },
                    docId: () => {
                        return this._docId;
                    },
                    payload: () => {
                        if (useFor && useFor === 'differenceChecker') {
                            return {};
                        }
                    },
                    field: () => {
                        return field
                    },
                    fieldValue: () => {
                        this.modifiedFieldValue["oper"] = oper;
                        this.modifiedFieldValue["domain"] = this.values['domain'] || this.$rootScope.domain;
                        return this.modifiedFieldValue;
                    },
                    referCollection: () => {
                        if (field && typeof field === "object" && field.input_type === "gselect" && field.refer_collection) {
                            return {
                                collection: field.refer_collection,
                                value: this.fieldValue[field.name].value
                            };
                        }

                        if (field && fieldValue) {
                            return {
                                collection: field,
                                value: this.fieldValue
                            };
                        }

                        return {
                            collection: "",
                            value: ""
                        };

                    }
                }
            });

            if (name === "mapupdate.html")
                return modalInstance;

            modalInstance.result.then(function (selectedItem) {
            }, () => {
                this.$log.info('Modal dismissed at: ' + new Date());
                this.buttons.processing = false;
            });
        };

        this.tabSelected = (tabId) => {
            console.log("event:grid:111" + tabId);
            setTimeout(() => {
                this.$rootScope.$broadcast("event:grid:" + tabId);
            }, 500);
        };

        const viewSections = () => {
            this.$log.info(collection);
            const _url = `/pltf_collection_section/list?_search=true&nd=${new Date().getTime()}&rows=25&page=1&sidx=updated_on&sord=desc&project=name,active,action,collection,execution_time,order,domain,script,created_on,created_by,version,app,_id,domain&collection_name=${collection}`;
            this.$location.url(_url);
            // $location.search('collection', $scope.collection);
        };

        const viewRelations = () => {
            this.$log.info(collection);
            this.$rootScope.openv3('formrelations', null, {
                collection: 'form_relation',
                type: 'list',
                filter: { collection: collection }
            });
        };

        this.editurl = false;
        this.flipUrlState = () => {
            this.editurl = !this.editurl;
        };

        this.actions = {
            jsonView: jsonView,
            pdfView: pdfView,
            jsonDownload: jsonDownload,
            viewSections,
            viewRelations
        };

        const ready = (err, result) => {
            console.log(err, result);
            try {
                if (this.$rootScope.user.roles.indexOf("oad") > -1 || this.$rootScope.user.roles.indexOf("admin") > -1) {
                    this.access.upload = true;
                    this.access.download = true;
                    this.access.addfield = true;
                    this.access.json = true;
                    this.access.addfield = true;
                    this.access.form_admin = true;
                }

                if (this.$rootScope.user.roles.indexOf("download") > -1) {
                    this.access.download = true;
                }

                if (this.$rootScope.user.roles.indexOf("form_admin") > -1) {
                    this.access.form_admin = true;
                }
            } catch (e) {
                console.error(e);
            }

            this.$log.info('Ready');
            loadDocument(document, '');
        };
        NProgress.start();
        async.series(initiate, ready);
    };
}

OBTODocumentController.$inject = [
    '$window',
    '$timeout',
    '$compile',
    'pageService',
    '$http',
    '$routeParams',
    '$rootScope',
    '$location',
    'ribbon',
    '$uibModal',
    'API',
    '$localstorage',
    '$log',
    '$anchorScroll',
    'OB',
    '$route',
    '$document',
    '$ngRedux',
    '$scope'
];
const OBTODocument = {
    selector: "obtoForm", // <person-edit>
    templateUrl: ['$rootScope', ($rootScope) => {
        return $rootScope.viewFiles + '/form-component-base.html';
    }],
    bindings: {
        collection: '@',
        document: '@',
        embedded: '@'
    },
    controller: [
        '$window',
        '$timeout',
        '$compile',
        'pageService',
        '$http',
        '$routeParams',
        '$rootScope',
        '$location',
        'ribbon',
        '$uibModal',
        'API',
        '$localstorage',
        '$log',
        '$anchorScroll',
        'OB',
        '$route',
        '$document',
        '$ngRedux',
        '$scope',
        OBTODocumentController]

};

export default OBTODocument;
